"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = _interopRequireDefault(require("../../Input")),
    _manualLocationForm = require("../styles/manualLocationForm"),
    defaultedValue = function defaultedValue(a) {
  return a || "";
};

function ManualLocationForm(a) {
  var b = a.address,
      c = a.onChangeAddressField,
      d = a.disabled,
      e = b.country,
      f = b.state,
      g = b.street,
      h = b.unit,
      i = b.postCode,
      j = b.citySuburb;
  return _react["default"].createElement("div", {
    className: _manualLocationForm.MANUAL_LOCATION_FORM
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_manualLocationForm.INPUTS_CONTAINER, _manualLocationForm.STREET_INPUTS_CONTAINER)
  }, _react["default"].createElement(_Input["default"], {
    id: "unit",
    label: "Unit/Level/Suite",
    defaultValue: defaultedValue(h),
    onChange: c("unit"),
    disabled: d
  }), _react["default"].createElement(_Input["default"], {
    id: "street-address",
    label: "Street Address",
    labelProps: {
      required: !0
    },
    defaultValue: defaultedValue(g),
    onChange: c("street"),
    disabled: d
  })), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_manualLocationForm.INPUTS_CONTAINER, _manualLocationForm.COUNTRY_INPUTS_CONTAINER)
  }, _react["default"].createElement(_Input["default"], {
    id: "city",
    label: "City/Suburb",
    labelProps: {
      required: !0
    },
    defaultValue: defaultedValue(j),
    onChange: c("citySuburb"),
    disabled: d
  }), _react["default"].createElement(_Input["default"], {
    id: "state",
    label: "State",
    labelProps: {
      required: !0
    },
    defaultValue: defaultedValue(f),
    onChange: c("state"),
    disabled: d
  }), _react["default"].createElement(_Input["default"], {
    id: "postal-code",
    label: "Postal/Zip Code",
    labelProps: {
      required: !0
    },
    defaultValue: defaultedValue(i),
    onChange: c("postCode"),
    disabled: d
  })), _react["default"].createElement(_Input["default"], {
    id: "country-input",
    label: "Country",
    labelProps: {
      required: !0
    },
    defaultValue: defaultedValue(e),
    onChange: c("country"),
    disabled: d
  }));
}

var _default = (0, _react.memo)(ManualLocationForm);

exports["default"] = _default;